(function(){
  // 23. 10. 2026 (Gasper): besedila prek window.KAI_T (kljuci kai.js.*), angleska rezerva ostane tu.
  var _T=window.KAI_T||{}; function t(k,d){ var v=_T[k]; if(typeof v!=='string'||!v||v.indexOf('Translation missing')===0) return d; return v; }
  function tf(k,d,vars){ var s=t(k,d); for(var vk in vars){ s=s.split('{'+vk+'}').join(vars[vk]); } return s; }
  var FLAVNAME={}; (window.KAI_FLAV||[]).forEach(function(f){ FLAVNAME[f.name]=t('flav_'+f.id,f.name); });
  function fshow(n){ return FLAVNAME[n]||n; }
  var PROP_FLAV=t('prop_flavour','Flavour'), PROP_PACK=t('prop_pack','Pack');
  var CFG = window.KAI_CONFIG || {};
  var THRESH = CFG.freeShipThreshold || 70;
  var CART = null;
  var CUR = 'EUR';
  var UPSELLS = [
    {name:'Raspberry', img:'https://cdn.shopify.com/s/files/1/0846/9508/9495/files/MALINA.png?v=1791208461'},
    {name:'Tropical Mango', img:'https://cdn.shopify.com/s/files/1/0846/9508/9495/files/mango_3d28690b-bab8-478b-a6d8-b041ec2fbdfe.png?v=1791210680'},
    {name:'Blueberry Vanilla', img:'https://cdn.shopify.com/s/files/1/0846/9508/9495/files/Navodila_za_darilno_pakiranje__Ker_je_nase_gele_potrebno_hraniti_v_hladilniku_vam_darilno_pakiranje_prilagamo_loceno_prazno._Gele_hranite_v_hladilniku_vse_do_trenutka_ko_boste_darilo.png?v=1791199366'}
  ];

  // Gift names/values MUST match kai-body-2.liquid (value stack) and the buy box settings.
  // Tiers MUST match kai-flavmap.js wanted(): 2+ units = recipe/tote, 3+ units = + Mini Probiotic Gummies (od 19. 10. 2026).
  var GIFTS = {
    recipe:{name:t('gift_recipes','Fan Favorite Sea Moss Recipes'), value:490, icon:'\u{1F4D6}'},
    tote:{name:t('gift_tote','KAI Coton Bag'), value:1000, icon:'\u{1F6CD}\u{FE0F}'},
    shipping:{name:t('gift_ship','Free Shipping'), value:0, icon:'\u{1F69A}'},
    mango:{name:t('gift_gum','Mini Probiotic Gummies'), value:1990, img:'https://cdn.shopify.com/s/files/1/0846/9508/9495/files/kai-mini-probiotic-gummies.webp?v=1792768673&width=400'},
    // BLACK FRIDAY 2026 (Claude, 25. 10. 2026)
    sp:{name:'Spiced Pear Sea Moss Gel', value:2690, img:'https://cdn.shopify.com/s/files/1/0846/9508/9495/files/SPICEDPEAR.png?v=1792931580&width=400'},
    wb:{name:'Peach Crumble Sea Moss Gel', value:2690, img:'https://cdn.shopify.com/s/files/1/0846/9508/9495/files/peachcrumble3.png?v=1790154691&width=400'},
    mask:{name:({sl:'Maska za obraz in lase',hr:'Maska za lice i kosu'})[(window.Shopify&&Shopify.locale)||'']||'Face & hair mask', value:2690, img:'https://cdn.shopify.com/s/files/1/0846/9508/9495/files/GIFT_CARD_77623754-bd10-44d2-820c-814fbbc8c33a.png?width=400'}
  };
  // Count PAID units, not the Pack label. Every jar is its own line, so removing a line must
  // lower the tier - reading maxJars off the Pack property would keep saying "3 Jars" forever.
  function giftsForCart(){
    var units=0;
    ((CART&&CART.items)||[]).forEach(function(it){
      var p=it.properties||{};
      if(p['_gift']) return;
      // 16. 10. 2026: isto pravilo kot kai-flavmap.js / kai-gift-auto.js - steje samo izdelek nad 10 EUR, ki ni darilni bon in nima "Gift" v imenu (ovoj, boni).
      if(it.gift_card) return; if(/gift/i.test(String(it.product_title||it.title||''))) return; var pr=(typeof it.original_price==='number')?it.original_price:(it.price||0); if(pr<=1000) return;
      units+=it.quantity;
    });
    if(window.kaiBfCart&&window.kaiBfCart(CART)){ if(units>=4) return ['recipe','tote','mango','sp','wb','mask','shipping']; if(units>=3) return ['recipe','tote','mango','sp','shipping']; if(units>=2) return ['recipe','tote','mango']; return []; }
    if(units>=3) return ['recipe','tote','mango','shipping']; // 3. darilo = mini probioticni gumiji (od 19. 10. 2026), 4. = free shipping
    if(units>=2) return ['recipe','tote'];
    return [];
  }
  var KAI_TIMER_MS=20*60*1000, _kti=null;
  function timerEnd(){
    try{ var k='kaiCartTimerEnd', now=Date.now(), v=localStorage.getItem(k);
      if(!v||parseInt(v,10)<=now){ v=String(now+KAI_TIMER_MS); localStorage.setItem(k,v); }
      return parseInt(v,10);
    }catch(e){ return Date.now()+KAI_TIMER_MS; }
  }
  function startTimer(){
    var box=document.getElementById('kai-cart-timer'), clock=document.getElementById('kai-timer-clock');
    if(!box||!clock) return;
    if(!CART||!CART.items.length){ box.style.display='none'; if(_kti){clearInterval(_kti);_kti=null;} return; }
    box.style.display='block';
    function upd(){ var rem=timerEnd()-Date.now(); if(rem<0)rem=0; var m=Math.floor(rem/60000), sec=Math.floor((rem%60000)/1000); clock.textContent=(m<10?'0':'')+m+':'+(sec<10?'0':'')+sec; }
    upd(); if(_kti) clearInterval(_kti); _kti=setInterval(upd,1000);
  }

  var root = document.createElement('div');
  root.id = 'kai-cart-root';
  root.innerHTML =
    '<div id="kai-cart-overlay"></div>' +
    '<aside id="kai-cart-drawer" aria-label="'+t('cart_title','YOUR CART')+'">' +
      '<div class="kai-cart-head">' +
        '<span class="kai-cart-title">'+t('cart_title','YOUR CART')+' <span id="kai-cart-badge">0</span></span>' +
        '<button type="button" id="kai-cart-close" aria-label="'+t('close','Close')+'">&times;</button>' +
      '</div>' +
      '<div id="kai-cart-timer" style="display:none;background:#E3E9EE;padding:9px 22px;font-size:12.5px;text-align:center;border-bottom:1px solid #E8E2DC;color:#080912"><span style="margin-right:5px">&#9202;</span>'+t('timer_html','Your cart &amp; free gifts are held for')+' <strong id="kai-timer-clock" style="color:#B4532E;font-variant-numeric:tabular-nums">20:00</strong></div>' +
      '<div class="kai-cart-ship"><p id="kai-ship-msg"></p><div class="kai-ship-track"><div id="kai-ship-bar"></div></div></div>' +
      '<div id="kai-cart-body"></div>' +
      '<div id="kai-cart-upsell"></div>' +
      '<div class="kai-cart-foot">' +
        '<div class="kai-cart-subrow"><span>'+t('subtotal','Subtotal')+'</span><span id="kai-cart-sub"></span></div>' +
        '<a href="/checkout" id="kai-cart-checkout" class="kai-cart-checkout">'+t('checkout','Checkout')+'</a>' +
        '<a href="/cart" class="kai-cart-viewcart">'+t('view_cart','View cart')+'</a>' +
      '</div>' +
    '</aside>';
  document.body.appendChild(root);

  function money(cents){
    try { return (cents/100).toLocaleString(undefined,{style:'currency',currency:CUR}); }
    catch(e){ return '€'+(cents/100).toFixed(2); }
  }
  function open(){ root.classList.add('open'); document.documentElement.style.overflow='hidden'; }
  function close(){ root.classList.remove('open'); document.documentElement.style.overflow=''; }
  window.kaiOpenCart = function(){ fetchCart(open); };
  window.kaiCloseCart = close;
  // kai-flavmap.js calls this after it sweeps orphaned gifts, so the drawer repaints.
  window.kaiRefreshCart = function(){ fetchCart(); };

  document.getElementById('kai-cart-close').onclick = close;
  document.getElementById('kai-cart-overlay').onclick = close;
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });

  function fetchCart(cb){
    fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){return r.json();})
      .then(function(c){ CART=c; if(c.currency) CUR=c.currency; render(); updateBadges(); if(cb) cb(); })
      .catch(function(){ if(cb) cb(); });
  }
  function updateBadges(){
    var n = CART ? CART.item_count : 0;
    var b=document.getElementById('kai-cart-badge'); if(b) b.textContent=n;
    var hb=document.getElementById('kai-cart-count'); if(hb) hb.textContent=n;
  }
  function render(){
    if(!CART) return;
    var body=document.getElementById('kai-cart-body');
    var sub = CART.items_subtotal_price;
    var threshCents = THRESH*100;
    var remain = threshCents - sub;
    var msg=document.getElementById('kai-ship-msg');
    var bar=document.getElementById('kai-ship-bar');
    if(remain>0){ msg.innerHTML=tf('ship_away_html','You\'re {x} away from <strong>FREE shipping</strong>',{x:money(remain)}); }
    else { msg.innerHTML=t('ship_unlocked_html','🎉 You\'ve unlocked <strong>FREE shipping!</strong>'); }
    bar.style.width=Math.min(100, Math.round((sub/threshCents)*100))+'%';
    if(!CART.items.length){
      body.innerHTML='<div class="kai-cart-empty"><p>'+t('cart_empty','Your cart is empty.')+'</p></div>';
      document.getElementById('kai-cart-upsell').innerHTML='';
      document.getElementById('kai-cart-sub').textContent=money(0);
      startTimer();
      return;
    }
    var h='';
    CART.items.forEach(function(it,idx){
      var p = it.properties || {};
      // Gift lines are rendered in the gifts block below, never as a removable paid line.
      if(p['_gift']) return;
      // 23. 10. 2026: vidna lastnost je lahko prevedena (Okus/Paket), notranji kljuc je _fkey/_pk (anglesko); stare vrstice imajo se Flavour/Pack.
      var packShown = p[PROP_PACK] || p['Pack'] || p['_pk'];
      var isPack = !!packShown;
      var fkey = p['_fkey'] || p['Flavour'] || p[PROP_FLAV];
      var name = fkey ? fshow(fkey) : it.product_title;
      var img = p['_img'] || it.image || '';
      var bits = [];
      if(it.variant_title) bits.push(it.variant_title);
      if(packShown) bits.push(packShown);
      if(p['Purchase type']) bits.push(t('subscription','Subscription'));
      var props = bits.length ? '<span>'+bits.join('</span><span>')+'</span>' : '';
      var qtyCtrl = isPack
        ? '<div class="kai-ci-qty kai-ci-qty-lock"><span>'+tf('qty','Qty {n}',{n:it.quantity})+'</span></div>'
        : '<div class="kai-ci-qty">'+
            '<button type="button" class="kai-qd" data-line="'+(idx+1)+'" data-q="'+(it.quantity-1)+'">&minus;</button>'+
            '<span>'+it.quantity+'</span>'+
            '<button type="button" class="kai-qd" data-line="'+(idx+1)+'" data-q="'+(it.quantity+1)+'">+</button>'+
          '</div>';
      h+='<div class="kai-ci" data-line="'+(idx+1)+'">'+
           '<img src="'+img+'" alt="">'+
           '<div class="kai-ci-mid">'+
             '<p class="kai-ci-title">'+name+'</p>'+
             '<div class="kai-ci-props">'+props+'</div>'+
             qtyCtrl+
           '</div>'+
           '<div class="kai-ci-right">'+
             '<p class="kai-ci-price">'+money(it.final_line_price)+'</p>'+
             '<button type="button" class="kai-ci-rm" data-line="'+(idx+1)+'">'+t('remove','Remove')+'</button>'+
           '</div>'+
         '</div>';
    });
    var _g=giftsForCart();
    if(_g.length){
      h+='<div style="margin-top:6px;padding-top:10px;border-top:1px dashed #DDD5CC">'+
         '<p style="font-size:11px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#080912;margin:0 0 4px">&#127873; '+tf('gifts_incl','{n} free gifts included',{n:_g.length})+'</p>';
      _g.forEach(function(gid){ var g=GIFTS[gid];
        var struck = g.value ? '<span style="color:#46505A;font-weight:500;text-decoration:line-through">'+money(g.value)+'</span> ' : '';
        h+='<div class="kai-ci" style="border-bottom:none;padding:8px 0">'+
             '<div style="width:62px;height:62px;border-radius:10px;background:#E3E9EE;display:flex;align-items:center;justify-content:center;font-size:26px;flex-shrink:0;overflow:hidden">'+(g.img?'<img src="'+g.img+'" alt="" style="height:42px;width:auto;object-fit:contain">':g.icon)+'</div>'+
             '<div class="kai-ci-mid"><p class="kai-ci-title">'+g.name+'</p><div class="kai-ci-props"><span>'+t('free_bonus_pack','Free bonus with your pack')+'</span></div></div>'+
             '<div class="kai-ci-right" style="justify-content:center"><p class="kai-ci-price">'+struck+'<span style="color:#080912;font-weight:800">'+t('free','FREE')+'</span></p></div>'+
           '</div>';
      });
      h+='</div>';
    }
    body.innerHTML=h;
    document.getElementById('kai-cart-sub').textContent=money(sub);
    body.querySelectorAll('.kai-qd').forEach(function(b){ b.onclick=function(){ changeLine(this.getAttribute('data-line'), parseInt(this.getAttribute('data-q'),10)); }; });
    body.querySelectorAll('.kai-ci-rm').forEach(function(b){ b.onclick=function(){ changeLine(this.getAttribute('data-line'), 0); }; });
    renderUpsell();
    startTimer();
  }
  function changeLine(line, qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({line:parseInt(line,10),quantity:qty})})
      .then(function(r){return r.json();})
      .then(function(c){ CART=c; render(); updateBadges(); });
  }
  function renderUpsell(){
    var wrap=document.getElementById('kai-cart-upsell');
    var PM=window.KAI_PRICEMAP||{};
    var vid=PM['Standard~1-Jar Pack'];
    if(!vid){ wrap.innerHTML=''; return; }
    var cards='';
    UPSELLS.forEach(function(u){
      cards+='<div class="kai-up-card">'+
        '<img src="'+u.img+'" alt="">'+
        '<div class="kai-up-mid"><p class="kai-up-name">'+fshow(u.name)+'</p><p class="kai-up-sub">'+t('up_sub','1 jar · add-on')+'</p></div>'+
        '<button type="button" class="kai-up-add" data-name="'+u.name+'" data-img="'+u.img+'">'+t('up_add','+ Add')+'</button>'+
        '</div>';
    });
    wrap.innerHTML='<p class="kai-up-head">'+t('up_head','Add &amp; save - popular flavours')+'</p>'+cards;
    wrap.querySelectorAll('.kai-up-add').forEach(function(b){ b.onclick=function(){ var nm=this.getAttribute('data-name'); var im=this.getAttribute('data-img'); this.textContent=t('adding','Adding…');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:[{id:parseInt(vid,10),quantity:1,properties:(function(){ var pp={}; pp[PROP_FLAV]=fshow(nm); pp['_fkey']=nm; pp['_img']=im; return pp; })()}]})})
        .then(function(r){return r.json();}).then(function(){ fetchCart(); }); }; });
  }
  // intercept the buy-box Add-to-Cart (capture phase, before the native submit)
  function hookForm(){
    var f=document.getElementById('kai-form');
    if(!f) return;
    f.addEventListener('submit', function(e){
      e.preventDefault(); e.stopImmediatePropagation();
      // Block until every jar in the pack has a flavour chosen.
      if(window.kaiValidate && !window.kaiValidate()){ return; }
      var items=window.KAI_ADD_ITEMS;
      if(!items || !items.length){ var fp=document.getElementById('kai-flavours'); if(fp) fp.scrollIntoView({behavior:'smooth',block:'center'}); return; }
      var btn=document.getElementById('kai-atc'); var orig=btn?btn.textContent:'';
      if(btn) btn.textContent=t('adding','Adding…');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:items})})
        .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
        .then(function(res){
          if(!res.ok){ // e.g. helper product not yet active/published → Shopify 422
            if(btn) btn.textContent = (res.d && res.d.description) ? t('unavailable','Unavailable - try again') : orig;
            setTimeout(function(){ if(btn) btn.textContent=orig; }, 2200);
            return;
          }
          window.kaiOpenCart(); if(btn) btn.textContent=orig;
        })
        .catch(function(){ if(btn) btn.textContent=orig; });
    }, true);
  }
  function hookHeader(){
    var link=document.getElementById('kai-cart-link');
    if(link){ link.addEventListener('click',function(e){ e.preventDefault(); window.kaiOpenCart(); }); }
  }
  function brandFixups(){
    // footer wordmark -> serif KAI (match header logo)
    var spans=document.querySelectorAll('footer span');
    for(var i=0;i<spans.length;i++){
      if(spans[i].textContent==='HEALTH'){
        spans[i].style.display='none';
        var prev=spans[i].previousElementSibling;
        if(prev){ prev.style.fontFamily="'Times New Roman',Georgia,serif"; prev.style.fontWeight='600'; prev.style.letterSpacing='0.18em'; }
      }
    }
  }
  function init(){ hookHeader(); hookForm(); brandFixups(); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  fetchCart();
})();